import TextField from '@mui/material/TextField';
import PropType from 'prop-types';
import { useId } from 'react';

const TextInput = ({
  error,
  helper,
  label,
  readOnly,
  value,
  startAdornment,
  endAdornment,
  maxLength,
  ...props
}) => {
  const inputId = useId();
  return (
    <TextField
      variant="filled"
      id={inputId}
      label={label}
      value={value || ''}
      error={error}
      helperText={helper}
      slotProps={{
        input: {
          endAdornment,
        },
        htmlInput: {
          readOnly,
          startAdornment,
          maxLength,
        },
      }}
      {...props}
    />
  );
};

TextInput.propTypes = {
  helper: PropType.node,
  label: PropType.string,
  error: PropType.bool,
  value: PropType.string,
};

export default TextInput;
